import { LockKeyhole, RefreshCw, Sparkle } from "lucide-react";
import { Link } from "react-router-dom";

const drawLabel=(loading,hasCards)=>{if(loading)return"Shuffling…";return hasCards?"Draw again":"Begin this pull"};

export const TarotAccessAction=({selected,authLoading,premium,loading,hasCards,onDraw})=>{
  if(authLoading&&!selected.free)return <button disabled data-testid="tarot-access-loading">Checking access…</button>;
  if(!selected.free&&!premium)return <Link to="/membership" data-testid="unlock-tarot-spread-link"><LockKeyhole/> Unlock this therapy</Link>;
  return <button onClick={onDraw} disabled={loading} data-testid="draw-cards-button">{hasCards?<RefreshCw/>:<Sparkle/>}{drawLabel(loading,hasCards)}</button>;
};